/**
 * Useful for preventing memory leaks, by doing state updates on unmounted components.
 * From https://usehooks-ts.com/react-hook/use-is-mounted */
import { useCallback, useEffect, useRef } from "react";

function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
}

export default useIsMounted;
